<template>
  <div class="customizer-navigation-bar">
    <span @click="gotoHome" class="back-to"><icon-left /> <span class="show-desktop">Return to product</span><span class="show-mobile">Return</span></span>

    <nav class="breadcrumbs" v-if="isDataLoaded">

      <span href="" class="breadcrumb__link breadcrumb__current">1 DESIGN</span>

      <span class="breadcrumbs__divider"><icon-right /></span>

      <span href="" class="breadcrumb__link">2 SUMMARY</span>

    </nav><!-- /.breadcrumbs -->
  </div><!-- /.customizer-navigation-bar -->
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "NavigationBar",
  computed: {
    ...mapState([
      "isDataLoaded"
    ])
  },
  methods: {
    gotoHome() {
      this.$router.replace('/');
    }
  }
}
</script>
